import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
justify-content: flex-start !important;
align-items: flex-start;
width: 100%;
flex-direction: column;
margin-left: 10%;
`
export const Title = styled.div`
color:#002E5C;
margin-top: 10px;
font-size: 20px;
font-weight: bolder;
line-height: 32px;
`
export const CampaignSectionWrapper = styled.div`
width: 100%;
display: flex;
justify-content: flex-start !important;
align-items:center;
margin-top: 20px;
`
export const CheckBoxWrapper = styled.div`
display: flex;
justify-content: center;
align-items:center;
width: 29%;
padding-top: 4%;

`
export const SelectTemplateSction = styled.div`
margin-top: 20px;
height: 20%;
overflow:hidden;
width: 88%;
height: 33em !important;
span{
    color:'#002E5C';
    font-size: 16px;
}
`
export const SelectFieldsWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;

`
export const SelectTypes = styled.div`
display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-direction: column;
padding-right: 20px;
margin-top: 20px;
`
export const SearchWrapper = styled.div`
margin-top: 20px;
width: 80%;
`
export const TemplateListContent = styled.div`
width: 93%;
` 
export const NoContentWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 100%;
`
export const TemplateName = styled.div`
  position: absolute;
  bottom: 0;
  width: 97%;
  margin-left: -10px;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
  background-color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    padding-left: 10px;
    font-size: 16px;
    color: "#404253";
    font-weight: 400;
  }
  border-top: 1px solid #e1e1e7;
`;